import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ThemeManagerService } from '~/services/theme-manager';
import { SharedService } from '~/services/sharedService';
import { LayoutManagerService, PORTAL_DATA } from '../layout/layout-manager';

@Component({
    selector: 'asap-popup',
    templateUrl: './popup.html',
    styleUrls: ['./popup.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'asap-popup',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class popupComponent {
  _theme: string;
  _title: string;
  _message: string;
  _note: string = '';
  _returnAfterOkCloseClick: boolean = false;
  OkCloseClicked: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _sharedService: SharedService,
    @Inject(PORTAL_DATA) public data: any
  ) {
    this._title = data.model.title;
    this._message = data.model.message;
    // this._returnAfterOkCloseClick = data.model.returnAfterOkCloseClick ?? false;

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }

  _onCancel() {
    this._close(true);
  }

  _close(isCloseClicked: boolean) {
    // Store note on the true app-wide singleton before detaching
    this._sharedService.pendingNote = isCloseClicked ? '' : (this._note || '');
    this._layoutManager.detachPopup(!isCloseClicked);
  }
}
